import { Component, Input } from "@angular/core";

export type PanelComplementarioTab = "tipo" | "referencias" | "transporte" | "observaciones" | "opciones" | "comisiones";

@Component({
	selector: "app-panel-complementario",
	templateUrl: "./panel-complementario.component.html",
	styleUrls: ["./panel-complementario.component.scss"],
})
export class PanelComplementarioComponent {
	@Input() showTransporte: boolean = false;
	@Input() showExportacion: boolean = false;
	@Input() showOpciones: boolean = false;
	@Input() showTipoNota: boolean = false;
	@Input() showComisiones: boolean = false;
	public activeTab: PanelComplementarioTab = "referencias";
	public expanded: boolean = false;

	get mostrarPestanaTransporte(): boolean {
		return this.showTransporte || this.showExportacion;
	}

	selectTab(tab: PanelComplementarioTab): void {
		if (this.expanded && this.activeTab === tab) {
			this.expanded = false;
			return;
		}
		this.activeTab = tab;
		this.expanded = true;
	}

	/** Abre una pestaña de forma explícita, sin aplicar el comportamiento de colapsar. */
	openTab(tab: PanelComplementarioTab): void {
		this.activeTab = tab;
		this.expanded = true;
	}
}
